import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
// import ReactTooltip from 'react-tooltip'
import config from '../../config'
// import format from '../../helpers/format'
// import convert from '../../helpers/convert'
import {
  // YesNo,
  // Grade,
  IyvListCompareSelectIcon,
  IyvListTdShareclassNameTicker,
  IyvListTdSriUssif,
  IyvListTdNetAssets,
  IyvListTdGroupCategory,
  IyvListTdReturns,
  IyvListTdFossilGrade,
  IyvListTdGenderEqualityRank,
  IyvListTdGenderEqualityScore,
  IyvListTdFossilFinanceGrade,
  IyvListTdPercent,
  IyvListTdGrade,
  IyvListTdDefault,
  // GenderEqualityScoreLabel,
  // Link,
  // LinkIcon
} from '../../components'
import Styles from './IyvListTable.css'


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListTable extends Component {
  static propTypes = {
    viewPanel: PropTypes.string,
    funds: PropTypes.array,
    selectVisible: PropTypes.bool,
    sort: PropTypes.string,
    isDesc: PropTypes.bool,
    clickShareclass: PropTypes.func,
    clickCompareSelect: PropTypes.func,
    clickColumnHeader: PropTypes.func,
    activeGrouping: PropTypes.string,
    cart: PropTypes.object,
    getCompareSelectStyles: PropTypes.func,
    resultsTableColumns: PropTypes.object
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    return (this.props.viewPanel==='results' ||
            this.props.viewPanel==='gef' ||
            this.props.viewPanel==='dei' ||
            this.props.viewPanel==='rji' ||
            this.props.viewPanel==='hrc' ||
            this.props.viewPanel==='performance' ||
            this.props.viewPanel==='iyv') &&
            this.props.funds.length > 0 ?
      <table styleName='table'>
        <thead>
          <tr styleName='header'>
            { /* select is not visible on mobile */
              this.props.selectVisible ?
                <IyvListThDefault
                  label='Compare'
                  prop=''
                  clickColumnHeader={this.props.clickColumnHeader}
                  sort={this.props.sort}
                  isDesc={this.props.isDesc}
                /> :
                null
            }
            { /* for each column: this.renderTh() */
              (this.props.resultsTableColumns
                [config.app.title]
                [this.props.viewPanel]
              ).map(
                (column, i) => {
                  let label = column[0]
                  let prop = column[1]
                  if (
                    config.app.title === 'Gender Equality Funds' &&
                    prop === 'gef_grp_norm'
                  ) {
                    switch (this.props.activeGrouping) {
                      case 'peer':
                        label = 'Gender equality rank, by category'
                        prop = 'gef_peer_norm'
                        break
                      case 'rank':
                        label = 'Gender equality rank, all funds'
                        prop = 'gef_rank'
                        break
                      default:
                        break
                    }
                  }
                  return <IyvListThDefault
                    key={'th-default-'+i}
                    label={label}
                    prop={prop}
                    clickable
                    clickColumnHeader={this.props.clickColumnHeader}
                    sort={this.props.sort}
                    isDesc={this.props.isDesc}
                  />
                }
              )
            }
          </tr>
        </thead>
        <IyvListTbody
          funds={this.props.funds}
          viewPanel={this.props.viewPanel}
          activeGrouping={this.props.activeGrouping}
          clickShareclass={this.props.clickShareclass}
          clickCompareSelect={this.props.clickCompareSelect}
          selectVisible={this.props.selectVisible}
          cart={this.props.cart}
          resultsTableColumns={this.props.resultsTableColumns}
          getCompareSelectStyles={this.props.getCompareSelectStyles}
        />
      </table> :
      null
  }
}


@CSSModules(Styles, {allowMultiple:true})
class IyvListThDefault extends Component {
  static propTypes = {
    sort: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    prop: PropTypes.string.isRequired,
    clickable: PropTypes.bool,
    isDesc: PropTypes.bool,
    clickColumnHeader: PropTypes.func.isRequired,
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    const activeStyle = this.props.prop === this.props.sort ?
      'col-active' :
      ''
    const activeClass = this.props.prop !== this.props.sort ?
        '' :
        this.props.isDesc ?
          'fa fa-angle-up' :
          'fa fa-angle-down'

    if (this.props.clickable) {
      return <th
        styleName='hd-col'
        onClick={this.props.clickColumnHeader(this.props.prop)}
      >
        <i
          styleName={activeStyle}
          className={activeClass}
        />
        <span>{this.props.label}</span>
      </th>
    } else {
      return (
        <th styleName='hd-col-no-hover'>
          <span>{this.props.label}</span>
        </th>
      )
    }
  }
}


@CSSModules(Styles, {allowMultiple:true})
class IyvListTbody extends Component {
  static propTypes = {
    funds: PropTypes.array,
    viewPanel: PropTypes.string,
    activeGrouping: PropTypes.string,
    clickShareclass: PropTypes.func,
    clickCompareSelect: PropTypes.func,
    selectVisible: PropTypes.bool,
    cart: PropTypes.object,
    resultsTableColumns: PropTypes.object,
    getCompareSelectStyles: PropTypes.func,
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    // error handling - if there are no shareclasses in the list, return null
    if (!this.props.funds || this.props.funds.length === 0) {
      return null
    }

    return <tbody>
      {
        this.props.funds.map((shareclass, idx) => {
          // if a view panel is active
          if (
            this.props.viewPanel==='results' ||
            this.props.viewPanel==='gef' ||
            this.props.viewPanel==='dei' ||
            this.props.viewPanel==='rji' ||
            this.props.viewPanel==='hrc' ||
            this.props.viewPanel==='performance' ||
            this.props.viewPanel==='iyv'
          ) {
            return <IyvListTbodyTr
              key={'iyv-tbody-tr-'+idx}
              shareclass={shareclass}
              clickShareclass={this.props.clickShareclass}
              clickCompareSelect={this.props.clickCompareSelect}
              idx={idx}
              activeGrouping={this.props.activeGrouping}
              viewPanel={this.props.viewPanel}
              selectVisible={this.props.selectVisible}
              cart={this.props.cart}
              resultsTableColumns={this.props.resultsTableColumns}
              getCompareSelectStyles={this.props.getCompareSelectStyles}
            />
          }
          return null
        })
      }
    </tbody>
  }
}


@CSSModules(Styles, {allowMultiple:true})
class IyvListTbodyTr extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired,
    clickShareclass: PropTypes.func.isRequired,
    clickCompareSelect: PropTypes.func.isRequired,
    idx: PropTypes.number.isRequired,
    activeGrouping: PropTypes.string,
    viewPanel: PropTypes.string, // isRequired
    selectVisible: PropTypes.bool,
    cart: PropTypes.object,
    resultsTableColumns: PropTypes.object,
    getCompareSelectStyles: PropTypes.func,
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    // (shareclass, idx, selectVisible=false)
    return <tr key={this.props.idx} styleName='row-fund' >
      { /* render the select box to add/remove shareclasses from the
          cart. select is not visible on mobile */ 
        this.props.selectVisible ?
          <IyvListTdCompareSelect
            shareclass={this.props.shareclass}
            clickCompareSelect={this.props.clickCompareSelect}
            cart={this.props.cart}
            getCompareSelectStyles={this.props.getCompareSelectStyles}
          /> :
          null
     }
     { /* for each column: this.renderTdByFieldname() */
        this.props.resultsTableColumns[config.app.title][this.props.viewPanel].map(
          (column, _idx) => {
            return <IyvListTd
              key={'iyv-td-' + this.props.idx + '-' + _idx}
              shareclass={this.props.shareclass}
              clickShareclass={this.props.clickShareclass}
              fieldName={column[1]}
              activeGrouping={this.props.activeGrouping}
            />
          }
        )
      }
    </tr>
  }
}


@CSSModules(Styles, {allowMultiple:true})
class IyvListTd extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired,
    clickShareclass: PropTypes.func.isRequired,
    fieldName: PropTypes.string.isRequired,
    activeGrouping: PropTypes.string
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    /**
     * Different logic based for different fieldnames
     * e.g. one render if it's the shareclass name; another if it's the gun
     * grade; etc.
     */
    if (['name'].includes(this.props.fieldName)) {
      return <IyvListTdShareclassNameTicker
        shareclass={this.props.shareclass}
        clickShareclass={this.props.clickShareclass}
      />
    }

    if (['ussif'].includes(this.props.fieldName)) {
      return <IyvListTdSriUssif
        shareclass={this.props.shareclass}
        clickShareclass={this.props.clickShareclass}
      />
    }

    if (['fund_net_assets'].includes(this.props.fieldName)) {
      return <IyvListTdNetAssets
        shareclass={this.props.shareclass}
        clickShareclass={this.props.clickShareclass}
      />
    }

    if (['morningstar_category_name', 'category_group'].includes(this.props.fieldName)) {
      return <IyvListTdGroupCategory
        shareclass={this.props.shareclass}
        clickShareclass={this.props.clickShareclass}
      />
    }

    if (['prospectus_net_expense_ratio', 'trailing_return_y1',
         'trailing_return_y3', 'trailing_return_y5',
         'trailing_return_y10', 'trailing_return_y15',
         'trailing_return_y20'].includes(this.props.fieldName)) {
      return <IyvListTdReturns
        shareclass={this.props.shareclass}
        clickShareclass={this.props.clickShareclass}
        fieldName={this.props.fieldName}
      />
    }

    if (['c2f5coogutweight'].includes(this.props.fieldName)) {
      return <IyvListTdFossilGrade
        shareclass={this.props.shareclass}
        clickShareclass={this.props.clickShareclass}
      />
    }

    if (['gef_grp_norm','dei_grp_norm','rji_grp_norm','hrc_grp_norm'].includes(this.props.fieldName)) {
      return <IyvListTdGenderEqualityRank
        shareclass={this.props.shareclass}
        clickShareclass={this.props.clickShareclass}
        activeGrouping={this.props.activeGrouping}
        fieldName={this.props.fieldName}
      />
    }

    if (['gef_score','dei_score','rji_score','hrc_score'].includes(this.props.fieldName)) {
      return <IyvListTdGenderEqualityScore
        shareclass={this.props.shareclass}
        clickShareclass={this.props.clickShareclass}
        fieldName={this.props.fieldName}
      />
    }

    if (['fossil_bank_score', 'fossil_insure_score'].includes(this.props.fieldName)) {
      return <IyvListTdFossilFinanceGrade
        shareclass={this.props.shareclass}
        clickShareclass={this.props.clickShareclass}
        fieldName={this.props.fieldName}
      />
    }

    if (['gm_weight','gr_weight','wff_civ_weight','pff_all_extreme_weight',
         'pff_all_high_weight','pp_high_weight','borders_high_weight',
         'pff_all_weight','cl_weight','po_producer_weight',
         'po_financier_weight','po_consumer_weight','po_all_weight',
         'mmc_weight','cm_weight','nw_weight','wff_mil_weight',
         'to_weight','tm_weight',
         't_all_weight'].includes(this.props.fieldName)) {
      return <IyvListTdPercent
        shareclass={this.props.shareclass}
        clickShareclass={this.props.clickShareclass}
        fieldName={this.props.fieldName}
      />
    }

    if (['grade_guns','grade_prison_industrial_complex','grade_fossil',
         'grade_deforestation','grade_gender_equality','grade_military',
         'grade_tobacco','grade_dei','grade_rji','grade_hrc'
      ].includes(this.props.fieldName)) {
      return <IyvListTdGrade
        shareclass={this.props.shareclass}
        clickShareclass={this.props.clickShareclass}
        fieldName={this.props.fieldName}
      />
    }

    return <IyvListTdDefault
      shareclass={this.props.shareclass}
      clickShareclass={this.props.clickShareclass}
      fieldName={this.props.fieldName}
    />
  }
}


@CSSModules(Styles, {allowMultiple:true})
class IyvListTdCompareSelect extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired,
    clickCompareSelect: PropTypes.func.isRequired,
    getCompareSelectStyles: PropTypes.func.isRequired,
    cart: PropTypes.object
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    return <td styleName='col col-compare'>
      <IyvListCompareSelectIcon
        shareclass={this.props.shareclass}
        clickCompareSelect={this.props.clickCompareSelect}
        getCompareSelectStyles={this.props.getCompareSelectStyles}
        cart={this.props.cart}
      />
    </td>
  }
}


/* @CSSModules(Styles, {allowMultiple:true})
class TdNumber extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired,
    clickShareclass: PropTypes.func.isRequired,
    fieldName: PropTypes.string.isRequired,
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    return <td
      styleName='col-right'
      onClick={this.props.clickShareclass(this.props.shareclass)}
    >
      {format.number(this.props.shareclass[this.props.fieldName], true, true, 0)}
    </td>
  }
} */


/* @CSSModules(Styles, {allowMultiple:true})
class TdCarbonFootprint extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired,
    clickShareclass: PropTypes.func.isRequired,
    fieldName: PropTypes.string.isRequired,
  }
  //
  constructor(props) {
    super(props)
    //
    const getFootprintRange = (val) => {
      const { low, avg, high, veryHigh } = config.footprintRanges.footprint
      if (val <= low) {
        return 'low'
      } else if (val <= avg) {
        return 'below'
      } else if (val <= high) {
        return 'above'
      } else if (val <= veryHigh) {
        return 'high'
      } else {
        return 'extreme'
      }
    }

    this.state = {
      footprintRange = getFootprintRange(
        convert.float(props.shareclass.usd_relative_footprint)
      )
    }
  }
  //
  render() {
    if (
      this.props.shareclass.usd_relative_footprint &&
      convert.float(this.props.shareclass.usd_relative_footprint) !== 0.0
    ) {
      return (
        <td
          styleName='col'
          onClick={this.props.clickShareclass(this.props.shareclass, 'carbon-footprint')}
        >
          <span styleName={'footrange-' + this.state.footprintRange}>
            <LinkIcon faclass='fa-circle'/>
          </span>
          &nbsp;
          {format.number(this.props.shareclass.usd_relative_footprint,false)}
        </td>
      )
    } else {
      return (
        <td
          styleName='col'
          onClick={this.props.clickShareclass(this.props.shareclass)}
        >
          <small><em>Not avail.</em></small>
        </td>
      )
    }
  }
} */
